// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-1bAs3EGr"};